import { ArrowBack, Close, Search } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import config from "../../../config/apiConfig";
import StoryList from "./StoryList/StoryList";
import StoryDetails from "./StoryDetails/StoryDetails";
import "./SideNav.scss";

type Props = {
    show: boolean;
    toggle: () => void;
};

const SideNav: React.FC<Props> = (props) => {
    const [id, setId] = useState<string>("");
    const [totalStories, setTotalStories] = useState(0);

    return (
        <aside
            className="write-scrap"
            style={{ display: !props.show ? "none" : "block" }}
        >
            <div
                className="scrapbook__container black"
                // style={{ display: "none"}}
            >
                <div
                    className="scrapbook__top"
                    style={{ display: "flex", justifyContent: "space-between" }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {id !== "" ? (
                            <div
                                onClick={() => setId("")}
                                className="close__btn"
                                style={{ marginRight: 8 }}
                            >
                                <ArrowBack style={{ pointerEvents: "none" }} />
                            </div>
                        ) : null}
                        <h4 style={{ fontWeight: 800, fontSize: "16px" }}>
                            {id === ""
                                ? `Your Scrapbook (${totalStories} stories)`
                                : "Back to stories"}
                        </h4>
                    </div>

                    <div onClick={props.toggle} className="close__btn">
                        <Close style={{ pointerEvents: "none" }} />
                    </div>
                </div>
                <div id="scrap__line"></div>
                <div className="scrapbook__list">
                    {id === "" ? (
                        <StoryList
                            selectStory={setId}
                            setTotalStories={setTotalStories}
                        />
                    ) : (
                        <StoryDetails id={id} />
                    )}
                </div>
            </div>
        </aside>
    );
};

export default SideNav;
